import _ from "lodash";
import React from "react";

const metricUnitsFromConfig = _.get(window, "rwgps.config.currentUser.metric_units", false);
export const MetricUnitsContext = React.createContext(metricUnitsFromConfig);

export const withMetricUnits = (Component) => (props) =>
  (
    <MetricUnitsContext.Consumer>
      {(metricUnits) => <Component metricUnits={metricUnits} {...props} />}
    </MetricUnitsContext.Consumer>
  );
